import React from 'react';
import './About.css'
const About = () => {
    return (

        <div className="about">
            <h1>About</h1>
            <p>A website is a collection of publicly accessible, interlinked Web pages that share a single domain name. Websites can be created and maintained by an individual, group, business or organization to serve a variety of purposes. Together, all publicly accessible websites constitute the World Wide Web.</p>

        </div>

    );
};

export default About;